import { useEffect, useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const LoopCarousel = ({ images, itemClass, testId, alt }) => {
  const ref = useRef(null);
  const paused = useRef(false);
  const list = [...images, ...images];

  const step = (dir) => {
    const el = ref.current;
    if (!el) return;
    const half = el.scrollWidth / 2;
    const w = el.firstElementChild?.getBoundingClientRect().width ?? 200;
    if (dir > 0 && el.scrollLeft >= half - 2) el.scrollLeft -= half;
    if (dir < 0 && el.scrollLeft < w) el.scrollLeft += half;
    el.scrollBy({ left: dir * (w + 14), behavior: "smooth" });
  };

  useEffect(() => {
    const id = setInterval(() => {
      if (!paused.current) step(1);
    }, 4200);
    return () => clearInterval(id);
  }, []);

  const onScroll = () => {
    const el = ref.current;
    if (el && el.scrollLeft >= el.scrollWidth / 2) el.scrollLeft -= el.scrollWidth / 2;
  };

  const Arrow = ({ dir, Icon }) => (
    <button
      type="button"
      data-testid={`${testId}-${dir > 0 ? "next" : "prev"}`}
      onClick={() => step(dir)}
      aria-label={dir > 0 ? "Próximo" : "Anterior"}
      className={`absolute top-1/2 z-10 grid h-11 w-11 -translate-y-1/2 place-items-center rounded-full bg-black/35 text-white ring-1 ring-white/25 backdrop-blur-md transition-[background-color,transform] duration-300 hover:scale-105 hover:bg-black/55 ${dir > 0 ? "right-2 md:right-4" : "left-2 md:left-4"}`}
    >
      <Icon size={18} />
    </button>
  );

  return (
    <div
      className="relative"
      data-testid={testId}
      onMouseEnter={() => (paused.current = true)}
      onMouseLeave={() => (paused.current = false)}
      onTouchStart={() => (paused.current = true)}
    >
      <div ref={ref} onScroll={onScroll} className="no-scrollbar flex gap-[14px] overflow-x-auto px-4 md:px-10">
        {list.map((src, i) => (
          <figure key={i} className={`shrink-0 overflow-hidden ${itemClass}`}>
            <img src={src} alt={alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out hover:scale-[1.04]" />
          </figure>
        ))}
      </div>
      <Arrow dir={-1} Icon={ChevronLeft} />
      <Arrow dir={1} Icon={ChevronRight} />
    </div>
  );
};
